<template>
  <div>
    <div class="title">Overdue Unrealised Benefits</div>
    <table v-if="overdueBenefits.length" class="acada-table">
      <colgroup>
        <col style="width: 35%" />
        <col style="width: 25%" />
        <col style="width: 25%" />
        <col style="width: 15%" />
      </colgroup>

      <tr>
        <th>Project Name</th>
        <th>Forecasted Date</th>
        <th>Savings Type</th>
        <th>Forecasted Amount</th>
      </tr>

      <tr
        v-for="benefit of overdueBenefits"
        :key="benefit.id"
        @click="goToProject(benefit.projectShortId)"
      >
        <td>
          <div class="details">
            <div class="right">
              <h4>{{ benefit.projectName }}</h4>
            </div>
          </div>
        </td>
        <td>{{ formatDate(benefit.forecastedDate, '-') }}</td>
        <td>{{ benefit.savingsType }}</td>
        <td>{{ formatCurrency(benefit.forecastedAmount, benefit.currencyId) }}</td>
      </tr>
    </table>
    <div v-else class="no-data">No benefits to show</div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import currency from "@/utils/currency";
import moment from "moment/moment";

export default {
  name: "overdue_pipeline_Projects",
  props: {
    overdueBenefits: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    async goToProject(id) {
      if (!this.projects[id]) {
        const _id = this.project_options.find(d => d.shortId === id).value;
        await this.$store.dispatch('getProjectDetail', _id);
      }
      this.$router.push({ name: 'ProjectDetail', params: { id } });
      document.querySelector('#main-view').scrollTo(0, 0);
    },
    formatCurrency(num, currencyId) {
      currency.locale(currencyId ? this.currencyCodeById(currencyId) : '');
      return currency(num).format('$0a.[0]');
    },
    formatDate(date, fallback) {
      if (!date) {
        return fallback;
      }
      return moment(date).format('D MMM YYYY');
    }
  },
  computed: {
      ...mapGetters(['currencyCodeById', 'rootCategory']),
    projects() {
      return this.$store.getters.projects;
    },
    all_projects() {
      return this.$store.getters.all_projects;
    },
    project_options() {
      return Object.keys(this.all_projects)
        .filter(key => key !== this.project_id)
        .map(key => {
          return {
            text: this.all_projects[key].name,
            value: this.all_projects[key].id,
            shortId: this.all_projects[key].shortId,
          };
        });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/_styles.scss';
  .title {
    display: flex;
    justify-content: center;
    font-size:  14px;
    font-weight:  bold;
    color: #263238;
  }
  .no-data {
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin: 30px 0;
    color: $sidebar-color;
    opacity: 0.5;
  }
</style>
